import { Injectable } from '@angular/core';
import { environment } from '@rocksoft/environment';
import { HubService } from './hub.service';

@Injectable({
  providedIn: 'root',
})
export class MdmHubService extends HubService {
  constructor() {
    super(`${environment.mdm.api}/hubs/mdm`);
  }
}
